

var _logger = require('xo-beaver/dist/logger');

var _integration = require('js/lib/integration');

var _miniBrowser = require('js/lib/miniBrowser');

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _constants = require('./constants');

var _squid = require('squid');

var _index = require('xo-device-info/dist/index');

var _fn = require('xo-login-components/src/login/fn');

var _index2 = require('xo-models/src/auth/index');

var _index3 = require('xo-models/src/checkout/index');

var _credit = require('xo-models/src/credit');

var _thirdPartyInfo = require('xo-third-party-components/src/thirdParty-info');

require('./stateChangeListener');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var getDeviceAndNetworkInfo = function getDeviceAndNetworkInfo() {
    var netInfo = navigator && navigator.connection || {};
    var memory = navigator && navigator.deviceMemory;
    return {
        type: netInfo.type, // Network type that browser uses
        effectiveType: netInfo.effectiveType, // 2g, 3g, wifi , etc
        downlink: netInfo.downlink, // Effective bandwidth estimate
        downlinkMax: netInfo.downlinkMax, // Upper bound on the downlink speed of the first network hop
        roundTripTime: netInfo.rtt, // Effective round-trip time estimate
        saveData: netInfo.saveData, // user has requested a reduced data usage mode,
        memory: memory // .5= 512Mib, 1=1024Mib, ...
    };
};

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$Middleware', function () {
    return [function angularDebug() {
        window.root = _angular.$rootScope;
        window.injector = _angular2['default'].element(document.body).injector();

        /**
         * Config experiment to overwrite the $apply method and use $eval instead of $apply if it would throw a digest inprog error.
         * This is mainly to address a Firefox bug with angular digest and timeouts, where timeouts can interrupt normal execution flow under certain circumstances
         * Bug described here: https://github.com/angular/angular.js/issues/10083
         *
         * Can remove as a config option if this is a stable change
         */
        if (_squid.$config.safeApply) {
            _logger.$logger.info('overwriting_angular_apply');
            var proto = Object.getPrototypeOf && Object.getPrototypeOf(_angular.$rootScope);

            if (!proto) {
                _logger.$logger.warn('overwriting_angular_apply_failed', {
                    reason: 'failed_to_get_prototype'
                });
            } else {
                var originalApply = proto.$apply;
                // If this gets used so many times, something is probably wrong so use original apply instead
                var skipAttempts = 10;

                proto.$apply = function (fn) {
                    if (skipAttempts && (_angular.$rootScope.$$phase === '$digest' || _angular.$rootScope.$$phase === '$apply')) {
                        skipAttempts--;

                        _logger.$logger.warn('inprog_error_skipped', {
                            stack: new Error().stack
                        });

                        this.$eval(fn);
                    } else {
                        originalApply.call(this, fn);
                    }
                };
            }
        }
    }, function waitForToken() {
        if (_squid.$util.isIFrame() && !_squid.$util.param('token') && !_squid.$meta.token) {
            return (0, _angular.$q)(function (resolve, reject) {
                _logger.$logger.info('await_token');

                window.addEventListener('message', function (event) {
                    var message = JSON.parse(event.data);

                    if (message.operation !== 'pass_token') {
                        return;
                    }

                    var token = message.token;

                    _logger.$logger.info('passed_token', { token: token });
                    _squid.$meta.token = token;

                    var $preloadApi = new _squid.$Api({ uri: 'preload' });

                    $preloadApi.retrieve({
                        params: { token: token }
                    }).then(function (response) {
                        $preloadApi.setTransientCache(response.data);
                        resolve();
                    })['catch'](reject);
                }, false);
            });
        }
    }, function checkToken() {
        var pattern = /^EC-[0-9A-Z]{17}$/;
        var beamPattern = /^BA-[0-9A-Z]{17}$/;
        // wps token are not preceeded with 'EC-'
        var wpsPattern = /^[0-9A-Z]{17}$/;
        var urlToken = (_squid.$util.param('token') || '').trim().slice(0, 20);
        var bodyToken = (_squid.$meta.token || '').trim().slice(0, 20);

        if (pattern.test(urlToken)) {
            _angular.$rootScope.token = urlToken;
        } else if (pattern.test(bodyToken)) {
            _angular.$rootScope.token = bodyToken;
        } else if (wpsPattern.test(urlToken)) {
            _logger.$logger.info('isWpsPattern');
            _angular.$rootScope.token = urlToken;
        } else if (wpsPattern.test(bodyToken)) {
            _logger.$logger.info('isWpsPattern');
            _angular.$rootScope.token = bodyToken;
        } else if (beamPattern.test(urlToken)) {
            _angular.$rootScope.token = urlToken;
            _logger.$logger.info('cart_exchange_failed', {
                token: _angular.$rootScope.token
            });
        } else if (beamPattern.test(bodyToken)) {
            _angular.$rootScope.token = bodyToken;
            _logger.$logger.info('cart_exchange_failed', {
                token: _angular.$rootScope.token
            });
        } else {
            return _angular.$q.reject(new _squid.$FallbackError({
                reason: 'no_token',
                product: 'error'
            }));
        }
    }, function resolveLocale() {
        var models = {};

        return (0, _squid.$populate)(models, {
            appData: _index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
            cart: _index3.$CheckoutCartModel.instance(_angular.$rootScope.token)
        })['finally'](function () {
            return _squid.$locale.retrieve({
                params: {
                    ipCountry: _squid.$meta.ipcountry,
                    localeTestUrlParam: _squid.$util.param('locale.test'),
                    checkoutShippingCountry: models.cart.get('purchase.shipping_address.country_code'),
                    merchantCountry: models.appData.get('merchant.merchant_country'),
                    checkoutSessionLocale: models.appData.get('merchant.merchant_locale'),
                    countryParam: _squid.$util.param('country.x'),
                    localeParam: _squid.$util.param('locale.x')
                }
            });
        });
    }, function fraudentInit() {
        return _fn.$fn.init();
    }, function setupIntegration() {
        return _miniBrowser.$miniBrowser.init(_angular.$rootScope.token);
    }, function frameBust() {

        if (!_integration.$integration.getConfig('CAN_FRAMEBUST')) {
            return;
        }

        if (_integration.$integration.getConfig('ALLOW_COLLECT_DATA')) {
            return;
        }

        return _miniBrowser.$miniBrowser.frameBust(_angular.$rootScope.token);
    }, function tokenExchange() {
        if (!_integration.$integration.getConfig('ALLOW_ONETOUCH_TOKEN_EXCHANGE')) {
            return;
        }

        if (_angular.$rootScope.isPartnerIntegration || !_squid.$util.isIFrame()) {
            return;
        }

        var auth = _index2.$AuthModel.instance();

        return auth.retrieve().then(function () {
            if (auth.logged_in || auth.remembered || !auth.refresh_token) {
                return;
            }

            return auth.action('onetouch');
        });
    }, function xcomponent() {
        if (window.xchild) {
            window.paypalCheckout = window.xchild;
        }

        if (window.xprops && window.xprops.init) {
            return _angular.$q.all([_index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve(), _index3.$CheckoutPayeeModel.instance(_angular.$rootScope.token).retrieve()]).then(function (_ref) {
                var checkoutAppData = _ref[0],
                    checkoutPayee = _ref[1];

                return window.xprops.init({
                    paymentToken: _angular.$rootScope.token,
                    merchantID: checkoutPayee.merchant.id,
                    cancelUrl: checkoutAppData.urls.cancel_url
                });
            });
        }
    }, function xcomponentAuth() {
        if (window.xprops && window.xprops.onAuth) {
            var auth = _index2.$AuthModel.instance();

            return auth.retrieve().then(function () {
                if (auth.access_token && (auth.logged_in || auth.remembered)) {
                    return window.xprops.onAuth({
                        accessToken: auth.access_token
                    });
                }
            });
        }
    }, function logPage() {
        _logger.$logger.info('href', {
            href: window.location.href,
            windowName: _angular.$window.name && _angular.$window.name.slice(0, 100)
        });

        var match = document.cookie.toString().match(/ectoken=([^;]+)/);

        if (match && match[1] === _angular.$rootScope.token) {
            _logger.$logger.info('returning_user_same_token');
        } else if (match && match[1] !== _angular.$rootScope.token) {
            _logger.$logger.info('returning_user_diff_token');
        } else {
            _logger.$logger.info('non_returning_user');
        }

        document.cookie = 'ectoken=' + _angular.$rootScope.token + '; expires=Fri, 31 Dec 9999 23:59:59 GMT;';

        if (window.performance && window.performance.navigation && _angular2['default'].isDefined(window.performance.navigation.type)) {
            var navigationType = {
                0: 'regular',
                1: 'reload',
                2: 'back_forward'
            }[window.performance.navigation.type];

            if (navigationType) {
                _logger.$logger.info('navigation_' + navigationType);
            }
        }
    }, function handleTagManager() {
        // ****** Tag Manager Code Start Here ***********
        window.dataLayer = {
            // Two letter country code of the current page's content
            contentCountry: _squid.$locale.country.toLowerCase(),
            // Two letter locale
            contentLanguage: _squid.$locale.lang.toLowerCase()
        };

        var tagManagerUrl = _squid.$config.urls.tagProdUrl;

        // Based on the environment, Tag Manager end point can be changed.
        // For now the local and stage end points are same.
        if (_squid.$config.deploy.isLocal() || _squid.$config.deploy.isStage()) {
            tagManagerUrl = _squid.$config.urls.tagStageUrl;
        }

        // Load bootstrap.js asynchronously
        (function (i, s, o, g, r, a, m) {
            i['tagManagerObject'] = r;
            i[r] = i[r] || function () {
                (i[r].q = i[r].q || []).push(arguments);
            };
            i[r].l = 1 * new Date();
            a = s.createElement(o);
            m = s.getElementsByTagName(o)[0];
            a.async = 1;
            a.src = g;
            m.parentNode.insertBefore(a, m);
        })(window, document, 'script', tagManagerUrl, 'tagManager');
    }, function logoutGuest() {
        var appData = _index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token);

        return _index2.$AuthModel.instance().retrieve().then(function (auth) {
            // For DE 2nd button transactions, guest accounts are allowed on return flow
            if (appData.get('merchant.merchant_country') === 'DE' && (appData.get('is_second_button_txn') || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit')) {
                if (_credit.$CreditDataModel.instance(_angular.$rootScope.token).getCapeKey()) {
                    return;
                } else {
                    return auth.action('logout');
                }
            }

            // if venmo transaction, we'll log the buyer back in by sending them back to the venmo app
            if (_thirdPartyInfo.thirdPartyExperience.isThirdPartyExperience(_angular.$rootScope.token)) {
                _thirdPartyInfo.thirdPartyExperience.resetThirdPartyExperience(); // removing token from experience flag
                _logger.$logger.info('venmo_login_retry');
            }

            if (auth.guest) {
                _logger.$logger.info('guest_logout');
                return auth.logoutAndRedirect('guest_logout');
            }
        });
    }, function checkProcessorDecline() {
        return _index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve().then(function (appData) {
            if (appData.flags.processor_declined) {
                _logger.$logger.info('processor_decline_transaction');
                var authModel = _index2.$AuthModel.instance();

                if (authModel.auth_state === 'IDENTIFIED' && !_squid.$util.param('redirectToHermes')) {
                    // guest
                    return (0, _squid.$dispatch)('xoon', {
                        token: _angular.$rootScope.token,
                        hermesXoonRedirect: true
                    }, {
                        fromState: 'checkout_init',
                        toState: 'guest',
                        'locale.x': _squid.$locale.lang + '_' + _squid.$locale.country,
                        'country.x': _squid.$locale.country
                    });
                }

                return;
            }
        });
    }, function logStart() {
        var networkAndDeviceData = getDeviceAndNetworkInfo();

        return _squid.$promise.hash({
            isMiniBrowser: _miniBrowser.$miniBrowser.isMiniBrowser(),
            isDirectIntegration: _miniBrowser.$miniBrowser.getDirectIntegration(_angular.$rootScope.token),
            isIframe: _miniBrowser.$miniBrowser.isFramed()
        }).then(function (flags) {
            var app_int_type = _index.$DeviceInfo.getAppIntegrationType();

            _logger.$logger.info('app_start_design', {
                'from': 'client_middleware',
                'to': 'process_app_start_design',
                is_directintegration: flags.isDirectIntegration ? 1 : 0,
                is_incontext: flags.isMiniBrowser || flags.isIframe ? 1 : 0,
                app_int_type: app_int_type,
                'screen_width': _angular.$window.innerWidth,
                'screen_height': _angular.$window.innerHeight,
                'device_memory': networkAndDeviceData.memory,
                'network_type': networkAndDeviceData.type,
                'network_effectiveType': networkAndDeviceData.effectiveType,
                'network_downlink': networkAndDeviceData.downlink,
                'network_downlinkMax': networkAndDeviceData.downlinkMax,
                'network_roundTripTime': networkAndDeviceData.roundTripTime,
                'network_saveData': networkAndDeviceData.saveData
            });
        });
    }, function logPerformance() {
        if (window.enablePerformance) {
            var keys = ['connectEnd', 'connectStart', 'domComplete', 'domContentLoadedEventEnd', 'domContentLoadedEventStart', 'domInteractive', 'domLoading', 'domainLookupEnd', 'domainLookupStart', 'fetchStart', 'loadEventEnd', 'loadEventStart', 'navigationStart', 'redirectEnd', 'redirectStart', 'requestStart', 'responseEnd', 'responseStart', 'secureConnectionStart', 'unloadEventEnd', 'unloadEventStart'];
            var timing = {};

            _angular2['default'].forEach(keys, function (key) {
                timing[key] = parseInt(window.performance.timing[key], 10) || 0;
            });

            var offset = timing.connectEnd - timing.navigationStart;

            if (timing.connectEnd && window.clientStartTime) {
                _angular2['default'].forEach(timing, function (time, name) {
                    if (time && _angular2['default'].isNumber(time)) {
                        _logger.$logger.info('timing_' + name, {
                            client_elapsed: time - timing.connectEnd - (window.clientStartTime - offset),
                            req_elapsed: time - timing.connectEnd
                        });
                    }
                });
            }

            _logger.$logger.info('timing', timing);

            if (window.performance.memory) {
                _logger.$logger.info('memory', window.performance.memory);
            }

            if (window.performance.navigation) {
                _logger.$logger.info('navigation', window.performance.navigation);
            }

            if (window.performance.getEntries) {
                var logged = [];
                var logResources = function logResources() {
                    _angular2['default'].forEach(window.performance.getEntries(), function (resource) {
                        if (!resource || !resource.name) {
                            return;
                        }

                        if (logged.indexOf(resource.name) === -1) {
                            logged.push(resource.name);
                        } else {
                            return;
                        }

                        if (resource.initiatorType) {
                            _logger.$logger.info(resource.initiatorType, resource);
                        }
                    });
                };

                logResources();
                setInterval(logResources, 500);
            }

            if (timing.connectEnd && timing.navigationStart && window.clientStartTime) {
                _logger.$logger.info('js_init', {
                    client_elapsed: 0,
                    req_elapsed: window.clientStartTime - offset
                });
            }
        } else {
            _logger.$logger.info('no_performance_data');
        }
    }, function logAuthState() {
        return _index2.$AuthModel.instance().retrieve().then(function (auth) {
            if (auth.logged_in) {
                _logger.$logger.info('user_logged_in');
            } else if (auth.remembered) {
                _logger.$logger.info('user_remembered');
            } else {
                _logger.$logger.info('user_not_logged_in');
            }
        });
    },

    // check for access token in the hash.
    function checkAccessToken() {
        if (window.xprops && window.xprops.accessToken) {
            return window.xprops.accessToken().then(function (accessToken) {
                _squid.$Api.addHeader('x-paypal-internal-euat', accessToken);
                return _index2.$AuthModel.instance().reload();
            });
        }

        var euat = _squid.$util.param('euat');

        if (euat) {
            var accessToken = euat === '1' ? window.location.hash.substr(2) : euat;

            if (accessToken) {
                _logger.$logger.info(euat === '1' ? 'access_token_from_hash' : 'access_token_from_param', {
                    access_token: accessToken
                });

                /* if (euat === '1') {
                    window.location.hash = '';
                } */

                var authModel = _index2.$AuthModel.instance();

                authModel.access_token = accessToken;

                if (window.xprops && window.xprops.onAuth) {
                    window.xprops.onAuth({ accessToken: accessToken });
                }
            }
        }
    },

    // check for FraudNet for Mobile View
    function enableFraudNetForMobileWebView() {
        if (_index.$DeviceInfo.isApp()) {
            return _index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve().then(function (appData) {
                return (0, _squid.$pxp)(_squid.$config.ulMeta.hermesnodePxpConfig, {
                    'ctx.COUNTRY': appData.merchant.merchant_country
                }, 'xo_hermesnode_fraudnet_webview_treatment', false, true).then(function (result) {
                    if (result && result.treatment_name) {
                        _angular.$window.enableFraudNetForMobileWebView = true;
                    }
                });
            });
        }
    },

    // Logs if service workers are enabled
    function isServiceWorkerSupported() {
        if ('serviceWorker' in navigator) {
            _logger.$logger.info('service_worker_supported');
        } else {
            _logger.$logger.info('service_worker_not_supported');
        }
    }, function forceCookiesDisabled() {
        if (_index.$DeviceInfo.isApp()) {
            return _index3.$CheckoutPayeeModel.instance(_angular.$rootScope.token).retrieve().then(function (payee) {
                if (~_squid.$config.forceCookiesDisabled.indexOf(payee.merchant.id)) {
                    _logger.$logger.info('force_cookies_disabled');
                    _squid.$Api.forceCookiesDisabled = true;
                }
            });
        }
    }, function checkFramed() {
        if (_squid.$util.isIFrame()) {
            // Set this as "framed" mode (X icon, escape hatch, etc.)
            document.documentElement.className += ' framed';
        }
    }, function loginViaEuat() {
        // log in user via euat prior to rendering login screen.
        if (_squid.$util.param('euat') === '1') {
            var auth = _index2.$AuthModel.instance();

            if (auth.accessToken() && !auth.loggedIn()) {
                return auth.reload({
                    headers: {
                        'x-paypal-internal-euat': auth.accessToken()
                    },
                    resultModel: auth,
                    success: function success() {
                        return delete auth.access_token;
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(name) {
                            throw new _squid.$FallbackError({
                                reason: name.toLowerCase(),
                                product: 'ux'
                            });
                        }
                    }
                });
            }
        }
    }, function checkForSDK() {
        var isSDKintegration = window.name && window.name.indexOf('xcomponent__ppcheckout') === 0 || window.name.indexOf('zoid__ppcheckout') === 0 || _squid.$util.param('xcomponent') || _squid.$util.param('zoid');

        var sdkLoaded = window.paypal && window.xprops && window.paypal.Checkout && window.paypal.Checkout.isChild();

        if (isSDKintegration && !sdkLoaded) {
            throw new Error('Checkout loaded in an SDK integration, but no xprops found. Maybe the sdk script failed to load in the child window.');
        }
    }, function urlFormatCheck() {
        // To verify the kind of urls being used for cancel and return.
        // Deeplink and universal urls have potential to affect integration
        // we need to log the use cases to keep track.
        return _index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve().then(function (appData) {
            var urls = appData.urls || {};
            // 'regular' being false implies we have a non-standard format.
            var regular = new RegExp(_constants.constants.regex.safeProtocols, 'g');
            // 'modifed' is to check whether our new regex can catch all use cases.
            var modifed = new RegExp(_constants.constants.regex.protocolsWithDeeplink, 'g');
            _logger.$logger.info('url_pattern_test', {
                cancel_url: {
                    regular: regular.test(urls.cancel_url),
                    modifed: modifed.test(urls.cancel_url)
                },
                return_url: {
                    regular: regular.test(urls.return_url),
                    modifed: modifed.test(urls.return_url)
                }
            });
        });
    }];
});

_logger.$logger;

_integration.$integration;

_miniBrowser.$miniBrowser;

_constants.constants;

_squid.$Api;

_squid.$Class;

_squid.$config;

_squid.$dispatch;

_squid.$FallbackError;

_squid.$locale;

_squid.$meta;

_squid.$populate;

_squid.$promise;

_squid.$pxp;

_squid.$util;

_index.$DeviceInfo;

_fn.$fn;

_index2.$AuthModel;

_index3.$CheckoutAppDataModel;

_index3.$CheckoutCartModel;

_index3.$CheckoutPayeeModel;

_credit.$CreditDataModel;

_thirdPartyInfo.thirdPartyExperience;


//////////////////
// WEBPACK FOOTER
// ./js/lib/middleware.js
// module id = ./js/lib/middleware.js
// module chunks = 0